import {requestWithToken} from "../apiConfigs/request";

export const fetchSyncHistoryList = (query) => {
  return requestWithToken({
    url: `/sync-history${query}`,
    method: 'GET'
  });
}